import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";

/** Old /portal/events/:slug page — registered participants go to the event space, others to the public page. */
export default function LegacyEventRedirect() {
  const { slug } = useParams();
  const [to, setTo] = useState(null);
  useEffect(() => {
    api.get(`/event-space/${slug}`)
      .then((r) => setTo(["not_registered", "cancelled"].includes(r.data.state) ? `/events/${slug}` : `/portal/event/${slug}/overview`))
      .catch(() => setTo(`/events/${slug}`));
  }, [slug]);
  return to ? <Navigate to={to} replace /> : <div className="p-10 text-sm text-neutral-500" data-testid="legacy-event-redirect">Chargement…</div>;
}
